export default __webpack_public_path__ + "static/media/0018.ad522797.png";